import {
  child,
  ref,
  update,
  get,
  limitToLast,
  query,
  getDatabase,
  orderByKey,
  orderByValue,
  startAfter,
  startAt,
  endAt,
  endBefore,
} from 'firebase/database';
import { auth, database } from '../config';
import { baseScreenshotsCount } from '../../components/shared/UserStatistic/TaskStatistic';

const yearMonth = `${new Date().getMonth()}-${new Date().getFullYear()}`;
const dayOfMonth = `${new Date().getDate()}`;

export const timestamp = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  new Date().getDate()
).getTime();

export const createReport = async (boardId: string, taskId: string, seconds: number) => {
  const databaseRef = ref(database);

  const userId = auth?.currentUser?.uid || '';

  const date = Date.now();

  const data = {
    date,
    seconds,
    boardId,
    taskId,
  };

  try {
    await update(child(databaseRef, `/tracking/${userId}/reports/${taskId}/`), data);
  } catch (e) {
    throw new Error();
  }
};

export const createActivity = async (taskId: string, seconds: number, boardId: string) => {
  const databaseRef = ref(database);

  const userId = auth?.currentUser?.uid || '';

  const date = Date.now();

  const data = {
    date,
    seconds,
    taskId,
  };

  try {
    await update(
      child(databaseRef, `/tracking/${userId}/activity/total/${yearMonth}/${dayOfMonth}/${taskId}`),
      { seconds, boardId }
    );
    await update(child(databaseRef, `/tracking/${userId}/activity/${timestamp}/${taskId}`), data);
  } catch (e) {
    throw new Error();
  }
};

export const recordScreen = async (taskId: string, screen?: string) => {
  const databaseRef = ref(database);

  const userId = auth?.currentUser?.uid || '';

  const date = Date.now();

  const data = {
    [date]: screen,
  };

  try {
    await update(
      child(databaseRef, `/tracking/${userId}/screenshots/${timestamp}/${taskId}`),
      data
    );
  } catch (e) {
    throw new Error();
  }
};

export const getReport = async (taskId: string, userId?: string) => {
  const uid = userId || auth.currentUser?.uid || '';
  const db = getDatabase();
  const reports = query(ref(db, `/tracking/${uid}/reports/${taskId}`));

  try {
    const res = await get(reports);
    return res.val();
  } catch (e) {
    console.log(e);
    throw new Error();
  }
};

export const getDayReport = async (userId: string, yearMonth: string, dayOfMonth: string) => {
  const db = getDatabase();
  const reports = query(ref(db, `/tracking/${userId}/activity/total/${yearMonth}/${dayOfMonth}`));
  try {
    const res = await get(reports);
    return res.val();
  } catch (e) {
    console.log(e);
    throw new Error();
  }
};

export const getMonthReport = async (userId: string, yearMonth: string) => {
  // const startDayOfMonth = `${range.startDate?.getDate()}`;
  // const endYearMonth = `${range.endDate?.getMonth()}-${range.endDate?.getFullYear()}`;
  // const endDayOfMonth = `${range.endDate?.getDate()}`;
  // TODO:
  // при клике на статистику конкретного пользователя открывать статистику за последний месяц по дням
  // вверху должны быть кноки переключения между месяцами (без дней) - по аналогии как в айфоне
  // рендер дней по аналогии с выводом дней в таймдокторе, при этом каждый день - является чекбоксом
  // при клике на конкретный день - появляется кнопка "смотреть статистику" и "выбрать все"
  // при клике на кнопку открывается статистика по выбранным доскам и выбранным дням месяца (которая сейчас)
  // при клике на задачу - открывается подробная статистика по ней:
  //    - сколько всего времени на нее потрачено
  //    - в какие дни работал
  //    - скрины
  const db = getDatabase();
  const reports = query(ref(db, `/tracking/${userId}/activity/total/${yearMonth}/`));
  try {
    const res = await get(reports);
    return res.val();
  } catch (e) {
    console.log(e);
    throw new Error();
  }
};

export const getTodayReport = async (taskId: string) => {
  const uid = auth.currentUser?.uid;
  const db = getDatabase();
  const reports = query(ref(db, `/tracking/${uid}/activity/${timestamp}/${taskId}`));

  try {
    const res = await get(reports);
    return res.val();
  } catch (e) {
    console.log(e);
    throw new Error();
  }
};

export const getScreenshotsByTaskId = async (
  taskId: string,
  userId: string,
  day: number,
  after: number
) => {
  const db = getDatabase();
  const reports = query(
    ref(db, `/tracking/${userId}/screenshots/${day}/${taskId}`),
    orderByKey(),
    endBefore(String(after)),
    limitToLast(baseScreenshotsCount)
  );

  try {
    const res = await get(reports);
    return res.val() ? Object.keys(res.val()).map((id) => ({ screen: res.val()[id], id })) : null;
  } catch (e) {
    console.log(e);
    throw new Error();
  }
};

export const getActivityByDay = async (uid: string, day: number) => {
  const db = getDatabase();
  const reports = query(ref(db, `/tracking/${uid}/activity/${day}`));

  try {
    const res = await get(reports);
    return res.val();
  } catch (e) {
    console.log(e);
    throw new Error();
  }
};
